<header></header>
<div class="flex flex-col lg:flex-row bg-[#F8F9FA]">
  <!-- sidenav -->
  <aside class="lg:sticky md:top-0">
    <p-sidebar #sidebarRef [(visible)]="sidebarVisible" styleClass="w-auto bg-transparent shadow-none">
      <ng-template pTemplate="headless">
        <span (click)="closeCallback()" class="z-50 pi pi-times text-white w-[1rem] h-[1rem] block lg:hidden absolute top-4 right-4"></span>
        <sidenav></sidenav>
      </ng-template>
    </p-sidebar>
  </aside>
 
  <div class="sticky top-0 bg-transparent border-b border-gray-300 p-4 rounded flex justify-start block lg:hidden" *ngIf="!sidebarVisible">
    <span (click)="sidebarVisible = true" class="cursor-pointer w-[2.5rem] h-[2.5rem] bg-white drop-shadow-md rounded leading-loose text-center">
      <i class="pi pi-list" style="font-size: 1.5rem; line-height: 2.5rem"></i>
    </span>
    <app-typography [component]="'h5'" [variant]="'header'" class="grow text-center"></app-typography>
  </div>
  <!-- main content-->
  <main class="grow p-6">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- <footer></footer> -->
